import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Websocket from './routes/websocket/';

class App extends React.Component {
  render() {
    return (
      <div className="main-app-container">
        <section className="app-page-container test">

          <div className="app-content-wrapper">
            <div className="app-content pb-0 full-width">
              <Switch>
                <Route path={`${this.props.match.path}`} component={Websocket}/>
              </Switch>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

module.exports = App;



// WEBPACK FOOTER //
// ./routes/app/index.js